import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//const routes: Routes = [
//  { path: '', redirectTo: '/psapp/home', pathMatch: 'full' },
//  {
//    path: 'psapp',
//    loadChildren: () => import('./psapp/psapp.module').then(m => m.PsAppModule), // Lazy load psapp module
//    data: { preload: true }
//  },
//  {
//    path: '',
//    loadChildren: () => import('./app/app.module').then(m => m.AppModule), // Lazy load app module
//    data: { preload: true }
//  }
//];

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    loadChildren: './app/app.module#AppModule',
    data: { preload: true }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: []
})
export class RootRoutingModule { }
